import * as XLSX from "xlsx";
import { toPersianNumbers } from "./toPersianNumbers";
import { miladiToShamsi } from "./miladiToShamsi";

/**
 * تابع خروجی اکسل عمومی
 * @param {Array} data - آرایه‌ای از آبجکت‌ها (مثل profiles)
 * @param {string} fileName - نام فایل خروجی
 * @param {Object} options - تنظیمات اختیاری (مثل عنوان فارسی ستون‌ها)
 */
export const exportToExcel = (data, fileName = "خروجی", options = {}) => {
  try {
    if (!data || data.length === 0) {
      console.warn("⚠️ داده‌ای برای خروجی وجود ندارد");
      return false;
    }

    // اگر ترجمه فارسی برای نام ستون‌ها داده شده
    const headersMap = options.headers || {};

    // تعیین ستون‌ها به صورت داینامیک از کلیدهای اولین ردیف
    const keys = Object.keys(data[0]);

    // ساخت داده نهایی با عنوان فارسی یا کلید اصلی
    const exportData = data.map((item, i) => {
      const row = {};
      row["ردیف"] = toPersianNumbers(i + 1);

      keys.forEach((key) => {
        const header = headersMap[key] || key;

        // 🔹 اگر ستون تاریخ ثبت‌نام است → تبدیل میلادی به شمسی
        if (header === "تاریخ ثبت‌نام" && item[key]) {
          row[header] =
            toPersianNumbers(miladiToShamsi(item[key])) ?? "---";
        } else {
          row[header] = (item[key] === null || item[key] === undefined || item[key] === "") ? "" : toPersianNumbers(item[key]);

        }
      });

      return row;
    });

    // ایجاد workbook
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);

    // تنظیم عرض پیش‌فرض ستون‌ها
    ws["!cols"] = Object.keys(exportData[0]).map(() => ({ wch: 15 }));

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(
      wb,
      `${fileName}_${new Date().toLocaleDateString("fa-IR")}.xlsx`
    );

    return true;
  } catch (error) {
    console.error("❌ خطا در تولید فایل اکسل:", error);
    return false;
  }
};
